module.exports = __webpack_public_path__ + "static/media/more-options-question-pink.ce70ff73.svg";